import { useCallback } from 'react';

import { useToast } from '../../hooks/useToast';

export const useTaxonomyVersionToast = () => {
  const toast = useToast();

  return useCallback(
    // `title` overrides the default copy for cases that are not a removal —
    // e.g. an unrecognised geography taxonomy, where nothing is dropped and the
    // viewer simply keeps their own setting.
    (id: string, filterName: string, title?: string) => {
      if (!toast.isActive(id)) {
        toast({
          title:
            title ??
            `Your ${filterName.toLowerCase()} filters were removed due to taxonomy changes. Please re-select them.`,
          status: 'warning',
          duration: 6000,
          isClosable: true,
          position: 'top-right',
          id,
        });
      }
    },
    [toast]
  );
};
